"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SDK_MESSAGES = exports.INTERFACE_MESSAGES = void 0;
exports.INTERFACE_MESSAGES = {
    ENV_INFO: 'ENV_INFO',
    ON_SAFE_INFO: 'ON_SAFE_INFO',
    TRANSACTION_CONFIRMED: 'TRANSACTION_CONFIRMED',
    TRANSACTION_REJECTED: 'TRANSACTION_REJECTED',
};
exports.SDK_MESSAGES = {
    SAFE_APP_SDK_INITIALIZED: 'SAFE_APP_SDK_INITIALIZED',
    SEND_TRANSACTIONS: 'SEND_TRANSACTIONS',
};
//# sourceMappingURL=messageIds.js.map